var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineAssignmentCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22H22V24H15V22ZM15 18H25V20H15V18ZM15 14H25V16H15V14ZM27 10H22.82C22.4 8.84 21.3 8 20 8C18.7 8 17.6 8.84 17.18 10H13C12.86 10 12.73 10.01 12.6 10.04C12.21 10.12 11.86 10.32 11.59 10.59C11.41 10.77 11.26 10.99 11.16 11.23C11.06 11.46 11 11.72 11 12V26C11 26.27 11.06 26.54 11.16 26.78C11.26 27.02 11.41 27.23 11.59 27.42C11.86 27.69 12.21 27.89 12.6 27.97C12.73 27.99 12.86 28 13 28H27C28.1 28 29 27.1 29 26V12C29 10.9 28.1 10 27 10ZM20 9.75C20.41 9.75 20.75 10.09 20.75 10.5C20.75 10.91 20.41 11.25 20 11.25C19.59 11.25 19.25 10.91 19.25 10.5C19.25 10.09 19.59 9.75 20 9.75ZM27 26H13V12H27V26Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineAssignmentCircle40Px);
export default __webpack_public_path__ + "static/media/ic_outline-assignment_circle-40px.2721502c78e072990ed7ff8083332d80.svg";
export { ForwardRef as ReactComponent };